import styled from 'styled-components';
import { Props } from '.';

export const Container = styled.div`
	position: relative;
	height: auto;
	border-radius: 10px;
	position: relative;
	display: flex;
	flex-direction: column;
	padding: 20px;
	gap: 10px;
`;

export const Title = styled.div`
	font-weight: 600;
	font-size: 24px;
	line-height: 28px;
	margin-top: 10px;
	color: #ffffff;
`;

export const Description = styled.div`
	margin-bottom: 10px;
	font-weight: 400;
	font-size: 15px;
	line-height: 18px;
	max-width: 70%;
	color: #ffffff;
`;

export const Image = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	width: ${({ width }) => width};
`;

export const Button = styled.button<Pick<Props, 'isInputEmpty'>>`
	background: linear-gradient(180deg, #fcfe88 0%, #bcfb6b 100%);
	border-radius: 5px;
	color: #46227c;
	font-weight: 600;
	font-size: 24px;
	line-height: 29px;
	letter-spacing: 0.3px;
	padding: 10px;
	margin-top: 10px;
	opacity: ${({ isInputEmpty }) => (isInputEmpty ? '0.5' : '1')};
	pointer-events: ${({ isInputEmpty }) => (isInputEmpty ? 'none' : 'auto')};
`;

export const ValueContainer = styled.div`
	background: rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	padding: 2px;
	display: flex;
`;

export const Input = styled.input`
	background: rgba(0, 0, 0, 0.01);
	max-width: 55%;
	border-radius: 5px;
	padding-left: 10px;
	font-weight: 700;
	font-size: 17px;
	line-height: 20px;
	color: #fff;
`;

export const FormRadioGroup = styled.div`
	width: 100%;
	margin: 0 auto;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;

	input[type='radio'] {
		display: none;
	}

	label {
		display: inline-block;
		cursor: pointer;
		padding: 0px 15px;
		line-height: 34px;
		user-select: none;
		font-weight: 700;
		font-size: 17px;
		line-height: 20px;
	}

	input[type='radio'] + label {
		background: rgba(0, 0, 0, 0.2);
		border-radius: 5px;
		color: #fff;
	}

	input[type='radio']:checked + label {
		background: linear-gradient(180deg, #fcfe88 0%, #bcfb6b 100%);
		border-radius: 5px;
		color: #46227c;
	}
`;

export const FormRadioGroupItem = styled.div`
	width: 100%;

	label {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
	}
`;
